import { render, staticRenderFns } from "./CheckBoxField.vue?vue&type=template&id=5c4a5282"
import script from "./CheckBoxField.vue?vue&type=script&lang=js"
export * from "./CheckBoxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports